module.exports = __webpack_public_path__ + "img/image 52.dcbec45e.svg";